import { FileSearch, FileStack, Store } from "lucide-react";
import { Dialog } from "./Dialog";

/**
 * First-run overlay. Shown once per person (see `lib/welcome`), dismissible.
 *
 * It exists because the workflow is not self-evident: an engineer arriving cold does not know
 * that documents are approved before they can be read, or that the market search is gated.
 * Naming the three steps up front is cheaper than discovering them by clicking.
 */
export function Welcome({ onGo, onClose }: { onGo: (v: "documents" | "extraction" | "vendor") => void; onClose: () => void }) {
  const steps = [
    { k: "documents" as const, icon: <FileStack size={18} />, t: "Approve the documents",
      d: "Choose which documents in a package the system may read. Nothing is opened without this." },
    { k: "extraction" as const, icon: <FileSearch size={18} />, t: "Recover a component's identity",
      d: "Enter a tag. The index finds candidate documents, you confirm one, and five identity fields come back with the page each came from." },
    { k: "vendor" as const, icon: <Store size={18} />, t: "Find a replacement",
      d: "From a confirmed identity, check obsolescence against published evidence and rank the options." },
  ];
  return (
    <Dialog title="Welcome to the Obsolescence Management Agent" onClose={onClose} className="overlay-card">
        <div className="body" style={{ background: "var(--color-surface)" }}>
          <p className="muted" style={{ fontSize: 14, marginBottom: 4 }}>
            Three steps, in order. You can start anywhere, but this is the path.
          </p>
          <div className="steps">
            {steps.map((s, i) => (
              <button type="button" className="step" key={s.k} onClick={() => onGo(s.k)}>
                <span className="num" aria-hidden="true">{i + 1}</span>
                <span>
                  <span className="t">{s.icon} {s.t}</span>
                  <span className="d">{s.d}</span>
                </span>
              </button>
            ))}
          </div>
          <button onClick={onClose}>Get started</button>
        </div>
    </Dialog>
  );
}
